import { DataHubService } from 'src/core/services/datahub';
import { ClickContentModuleDeleteSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentModuleDeleteSchema';
import { ClickContentModuleDuplicateSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentModuleDuplicateSchema';
import { ClickContentModuleEditSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentModuleEditSchema';
import { ClickContentModuleMenuSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentModuleMenuSchema';
export function getModuleType(module) {
    if (module.paidModule)
        return 'PAID';
    if (module.extra)
        return 'EXTRA';
    return 'MAIN';
}
export const DispatchDatahubEvents = {
    clickContentModuleMenuSchema(module) {
        DataHubService.sendEvent({
            schema: new ClickContentModuleMenuSchema({ moduleType: getModuleType(module) })
        });
    },
    clickContentModuleEditSchema(module) {
        DataHubService.sendEvent({
            schema: new ClickContentModuleEditSchema({ moduleType: getModuleType(module) })
        });
    },
    clickContentModuleDuplicateSchema(module) {
        DataHubService.sendEvent({
            schema: new ClickContentModuleDuplicateSchema({ moduleType: getModuleType(module) })
        });
    },
    clickContentModuleDeleteSchema(module) {
        DataHubService.sendEvent({
            schema: new ClickContentModuleDeleteSchema({ moduleType: getModuleType(module) })
        });
    }
};
